// extracted by mini-css-extract-plugin
export default {"scoreDisplay":"VKZn5bIX","mobile":"mobile","scoreValue":"Btq85zLn","starWrapper":"K63bRxtw","stars":"Bnc5mMJm","starHalf":"aqUylG37","star":"Abs7ghrv"};